import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=c7c80b88&scoped=true&"
import script from "./VerifyEmail.vue?vue&type=script&lang=ts&"
export * from "./VerifyEmail.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=c7c80b88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c80b88",
  null
  
)

export default component.exports